export const genericFilter = (data, columns, query) => {
  return data && columns
    ? data.filter((value) =>
        columns.some((col) => {
          // Get the mapping function from column if it exists.
          let search = col["search"];

          // If mapping column does not exist, return undefined to move to next.
          if (!search) return undefined;

          // Convert value to string for later search.
          let result = search(value) ?? "";

          // Set to lower case before checking if query exists.
          return result.toString().toLocaleLowerCase().includes(query);
          //search(value).toLocaleLowerCase().includes(query);
        })
      )
    : undefined;
};

export default genericFilter;
